const editableFieldLevel = {
    NOT_EDITABLE : -1,

    ALWAYS_EDITABLE : 0,

    EDITABLE_THRU_CREATE_APPLICATION : 5,

    EDITABLE_THRU_CREATE_ENDORSEMENT : 5,

    EDITABLE_THRU_CREATE_REWRITE : 5,

    EDITABLE_THRU_SUBMIT : 10,

    EDITABLE_THRU_RATING : 15,

    EDITABLE_THRU_PRICING : 20,

    EDITABLE_THRU_QUOTING : 25,

    EDITABLE_THRU_BINDING : 30,

    EDITABLE_THRU_ISSUANCE : 35,

    EDITABLE_THRU_POST_ISSUANCE : 100,

    EDITABLE_THRU_REQUEST_CANCELLATION : 100,

    EDITABLE_THRU_SUBMIT_CANCELLATION : 101,

    EDITABLE_THRU_CANCELLATION : 102,

    EDITABLE_THRU_POST_CANCELLATION : 200,

    EDITABLE_THRU_REPORT_GENERATE : 305,

    EDITABLE_THRU_REPORT_POST_GENERATE : 310

};

angular.module('gw-um-j2js')
    .constant('editableFieldLevel', editableFieldLevel);